import styled from 'styled-components';

export const BannerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

interface BannerProps {
  $almostAtLimit: boolean
}

export const Banner = styled.div<BannerProps>`
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: ${({ theme, $almostAtLimit }) => ($almostAtLimit ? theme.palette.error.main : theme.palette.warning.main)};
  padding: 8px 32px;
  text-align: center;
`;
